import { DeleteOutline } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AddMoreButton from '../../../FormFields/AddMoreButton';
import PhysicianSection from './PhysicianSection';

PhysicianSectionAddMore.propTypes = {
  isEditable: PropTypes.bool,
  fieldName: PropTypes.string,
  physicianTypeId: PropTypes.number,
};

export default function PhysicianSectionAddMore({ isEditable, fieldName, physicianTypeId }) {
  const { control, setValue } = useFormContext();
  const { fields, append } = useFieldArray({ control, name: fieldName, keyName: '_id' });
  const watchedValues = useWatch({ control, name: fieldName }) || [];
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);
  const disabled = !isEditable || isCanceled;
  const visibleFields = fields
    .map((field, idx) => ({ field, idx }))
    .filter(({ idx }) => !watchedValues[idx]?.deleteFlag);

  const handleDelete = (idx) => {
    setValue(`${fieldName}[${idx}].deleteFlag`, true, { shouldDirty: true });
  };

  return (
    <>
      {visibleFields.map(({ field, idx }) => (
        <Grid container item xs={12} alignItems="center" spacing={1} key={field._id}>
          <Grid item xs={visibleFields.length > 1 ? 11.5 : 12}>
            <PhysicianSection isEditable={isEditable} fieldName={`${fieldName}[${idx}]`} showTitleQuestion />
          </Grid>
          {visibleFields.length > 1 && (
            <Grid item xs={0.5}>
              <IconButton onClick={() => handleDelete(idx)} disabled={disabled} color="error">
                <DeleteOutline />
              </IconButton>
            </Grid>
          )}
        </Grid>
      ))}
      <Grid item xs={12}>
        <AddMoreButton
          buttonLabel="Add more"
          disabled={disabled}
          handleAddMoreClick={() =>
            append({
              id: 0,
              title: null,
              firstName: null,
              lastName: null,
              contracts: [],
              deleteFlag: false,
              physicianTypeId,
            })
          }
        />
      </Grid>
    </>
  );
}
